import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ROUTES from "../../utils/routes.js";
import { isPWA } from "../../utils/helpers";
import INTOUCH_API from "../../services/Api";
import Game from "../../store/Game";
import useCurrentGame from "../../hooks/useCurrentGame";
import PersonalAccount from "../../store/PersonalAccount";
import { buildShareLink, shareApp } from "../../utils/share";

// Порядок пунктов — ТЗ Этап 2 п.6.2: верх — ЛК, игра, анкета, магазин;
// низ — правила, отзыв, поддержка, поделиться, язык, на гл. экран, выйти.
// Бейдж баллов (некликабельный) рендерится над верхним блоком в index.jsx.
const menuItems = {
  top: [
    {
      icon: "profile_gradient",
      tKey: "profile",
      action: "toProfile",
    },
    {
      icon: "butterfly_gradient",
      tKey: "intouch_game",
      action: "toInGame",
    },
    {
      icon: "small_insight_form_icon",
      tKey: "insight_form",
      action: "toInsightQuestionnaire",
    },
    {
      icon: "shop_icon",
      tKey: "shop",
      action: "toShop",
    },
  ],
  bottom: [
    {
      icon: "bookmark_gradient",
      tKey: "rules_game",
      action: "toRules",
    },
    {
      icon: "pencil_gradient",
      tKey: "leave_feedback",
      action: "toLeaveReview",
    },
    {
      icon: "support_gradient",
      tKey: "tech_support",
      action: "toTechSupport",
    },
    {
      icon: "share_gradient",
      tKey: "share",
      action: "toCompatibilityShare",
    },
    {
      icon: "browser_gradient",
      tKey: "language_change",
      action: "changeLanguage",
    },
    ...(isPWA()
      ? []
      : [
          {
            icon: "main_screen",
            tKey: "add_main_screen",
            action: "toPwaInstructions",
          },
        ]),
    {
      icon: "bigger_logout",
      tKey: "logout_acc",
      action: "logout",
    },
  ],
};

const INSIGHT_IC = "small_insight_form_icon";

export default function useViewController(iconKeys) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setGame } = useCurrentGame();
  const [items, setItems] = useState(() => menuItems);

  useEffect(() => {
    if (Array.isArray(iconKeys) && iconKeys.length) {
      const filteredItemsTop = menuItems.top.filter(
        (item) => iconKeys.find((k) => k === item.icon) === undefined
      );
      const filteredItemsBottom = menuItems.bottom.filter(
        (item) => iconKeys.find((k) => k === item.icon) === undefined
      );
      setItems({
        top: filteredItemsTop,
        bottom: filteredItemsBottom,
      });
    } else {
      setItems({
        top: menuItems.top,
        bottom: menuItems.bottom,
      });
    }
  }, [iconKeys]);

  const toPath = (path) => {
    navigate(path);
  };

  const startDemoGame = async () => {
    const demoForm = {
      type: "DEMO",
    };
    demoForm.userId = PersonalAccount.user.id;
    await INTOUCH_API.requestManager(
      "createDemoGame",
      demoForm,
      (response) => {
        Game.getCards("questions_cards_demo", true, null);
        Game.setGame(response.data);
        setGame(response.data);
        if (
          !PersonalAccount.user.gameIdsByMeets.some(
            (id) => id === response.data.id
          )
        ) {
          navigate(ROUTES.MEET_PAGE);
        }
      },
      (error) => {
        // Обновление 16.07: продажа повторных тестов отменена — тесты создаются
        // без ограничений, гейта FREE_TEST_ALREADY_USED на бэке больше нет
        console.log(error);
      },
      () => {}
    );
  };

  const shareCompatibilityPage = async () => {
    await shareApp({
      url: buildShareLink(PersonalAccount.user?.refCode),
      text: t("share.invite_text"),
      sentryTag: "BurgerMenu",
    });
  };

  return {
    toPath,
    items,
    shareCompatibilityPage,
    startDemoGame,
  };
}
